import { useEffect, useState } from 'react'
import { Text, YStack } from 'tamagui'
import { useLink } from 'solito/link'
import { useSubscriptionInfo } from 'app/utils/global-store/subscriptionStore'
import { isWeb } from '@my/ui'

export const PaymentIssueBanner = () => {
  const [isVisible, setIsVisible] = useState(false)
  const { hasPaymentIssue } = useSubscriptionInfo()
  const billingLink = useLink({ href: '/settings/billing' })

  useEffect(() => {
    if (hasPaymentIssue) {
      setIsVisible(true)
      // Set CSS custom property for banner height
      if (isWeb) {
        document.documentElement.style.setProperty('--payment-banner-height', '29px')
      }
    } else {
      const timeout = setTimeout(() => {
        setIsVisible(false)
        // Remove CSS custom property
        if (isWeb) {
          document.documentElement.style.setProperty('--payment-banner-height', '0px')
        }
      }, 2000)
      return () => clearTimeout(timeout)
    }
  }, [hasPaymentIssue])

  if (!isVisible) return null

  return (
    <YStack
      position="fixed"
      top={0}
      left={0}
      right={0}
      zIndex={10001} // Higher than header z-index (1000)
      backgroundColor="$red10Light"
      paddingVertical="$2"
      alignItems="center"
      animation="quick"
      enterStyle={{ opacity: 0, y: -40 }}
      exitStyle={{ opacity: 0, y: -40 }}
      opacity={1}
      y={0}
      cursor="pointer"
      {...billingLink}
    >
      <Text color="$white1" fontWeight="700" fontSize="$3" letterSpacing={-0.3}>
        Payment issue - please update your payment method to avoid cancellation
      </Text>
    </YStack>
  )
}